import React from 'react'
import { Button, notification } from 'antd'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import { ItemList } from '~components'
import { getCurrentUser } from '~context'
import { PageLayout } from '~stories'

import './RedirectsList.modules.css'

const PAGE_TITLE = 'Redirects'
const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}

const getRedirectLink = (redirect) => <a href={`/redirects/${redirect._id}/edit`}>{String(redirect.id).toUpperCase()}</a>

const columnData = [
  {
    dataIndex: 'id',
    render: (text, redirect) => getRedirectLink(redirect),
    sorter: true,
    title: 'ID',
    width: '30%'
  },
  {
    dataIndex: 'source',
    title: 'Source',
    width: '30%'
  },
  {
    dataIndex: 'destination',
    title: 'Destination',
    width: '30%'
  }
]

const addNewRedirect = isContentEditor => {
  return (
    <Route render={({ history }) => (
      <Button
        key="1"
        onClick={() => {
          isContentEditor
            ? history.push('/redirects/new')
            : notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
        }}
        type="primary"
      >
        Add Redirect
      </Button>
    )} />
  )
}

const RedirectsList = () => {
  const { userDetails: { isContentEditor } } = getCurrentUser()

  return (
    <PageLayout extra={[addNewRedirect(isContentEditor)]} title={PAGE_TITLE}
    >
      <div className="venues-layout-background">
        <ItemList columns={columnData} resource='redirects' />
      </div>
    </PageLayout>
  )
}

RedirectsList.propTypes = {
  allRedirects: PropTypes.array,
  message: PropTypes.string,
  status: PropTypes.bool
}

export default RedirectsList
